import { render, staticRenderFns } from "./btn-tertiary3.vue?vue&type=template&id=46d651da&scoped=true&"
import script from "./btn-tertiary3.vue?vue&type=script&lang=js&"
export * from "./btn-tertiary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d651da",
  null
  
)

export default component.exports